
import Classify from '@/components/classify/index'
import Technology from '@/components/technology/index'
import Humanity from '@/components/humanity/index'
import Notice from "./notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  scrollToTop: true,
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: 'HomeBanner',
  components: {
    CommonTitle,
    BannerTop,
    Classify,
    Technology,
    Humanity,
    Notice
  },
  data() {
    return {
      logo: require('@/static/images/headerLogo.png'),
      address: require('@/static/images/030.png'),
      tel: require('@/static/images/031.png'),
      cooperativePartnerList: [
        {path: require('@/static/images/logo/logo-13.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-14.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-15.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-16.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-17.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-18.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-19.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-20.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-21.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-22.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-23.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-24.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-25.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-26.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-27.jpg'), title: '合作伙伴',},
        {path: require('@/static/images/logo/logo-28.jpg'), title: '合作伙伴',},
      ]
    }
  },
  mounted() {
    if (window.location.hash) {
      this.$nextTick(() => {
       setTimeout(() => {
         this.goAnchor(window.location.hash)
       }, 500)
      })
    }
  },
  methods: {
    goNext(path){
      this.$router.push(this.localePath(path));
    },
    goAnchor(selector) {
      // 获取锚点元素
      let anchor = this.$el.querySelector(selector)
      anchor.scrollIntoView()
    }
  }
}
